<template>
    <div>
        <ul>
            <li v-for="projectLine in projectLines" v-bind:key="projectLine['.key']">
            <small>{{ projectLine.name }} <a v-if="enableFields" class="delete is-small" @click="deleteProjectLine(projectLine['.key'])"/></small>
            </li>
        </ul>
        <span class="field has-addons">
            <span class="control">
                <input type="text" class="input is-small" v-model="projectLineName" :placeholder="$t('input.typeName')" :disabled="!enableFields">
            </span>
            <span class="control">
                <input type="submit" class="button is-small is-primary" value="Opret projektlinje" @click="addCustomProjectLines()" :disabled="!enableFields">                   
            </span>
        </span> 
    </div>
</template>

<script>
import firebase from '@/firebase'
import _ from 'lodash'

export default {
    name: 'InputCustomProjectLine',
    props: {
        project: String,
        enableFields: Boolean,
    },
    data() {
        return {
            projectLineName: '',
        }
    },
    firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        return {
            projectLines: {
                source: firebase.database().ref('/organisations/' + tenantid + '/settings/customProjectLines').orderByChild('project').equalTo(this.project),
                asObject: false,
            },
        }
    },
    methods: {
        deleteProjectLine(line) {
            this.$firebaseRefs.projectLines.child(line).remove();
        },
        addCustomProjectLines(){
            const projectLine = {
                project: this.project,
                name: this.projectLineName,
                timestamp: moment().format(),
                uid: JSON.parse(localStorage.getItem('profile')).user_id
            }
            this.$firebaseRefs.projectLines.push(projectLine);
        }, 
    }
}
</script>

<style>

</style>
